<!--服务中-->
<template>
  <div class="inService-container" :style="'min-height:'+min_heights+'px;'">
    <div class="inService-content" v-if="orderData.length>0">
      <table class="table-header">
        <tr>
          <th class="th-first">商品名称</th>
          <th style="width: 12.5%;">收货人</th>
          <th style="width: 12.5%;">金额</th>
          <th style="width: 12.5%;">订单状态</th>
          <th style="width: 12.5%;">操作</th>
        </tr>
      </table>
      <order v-for="order of orderData" :rows="order" v-if="order.state==6 || order.state==1 || order.state==2" class="order-table"/>
      <!-- 分页 -->
<!--      <page :total="tablePage.total" class="pagination" @currentPage="currentPage" :limit="tablePage.pageSize" style="padding: 10px 25px 15px 10px;"/>-->
    </div>
    <div v-else class="inService-content">
      <el-empty>
        <div slot="description">
          <p style="font-size: 16px;color: #2d3237;">您还没有相关的订单</p>
          <p style="font-size: 14px;color: #666666">可以去看看有哪些想买的</p>
        </div>
      </el-empty>
    </div>
  </div>
</template>

<script>
import Order from "@/components/table/order";
import page from "@/components/page/page";
import {getOrdersInfo} from "@/api/orderApi";
export default {
  name: "inService",
  components: {Order,page},
  data() {
    return {
      orderData: [],
      min_heights: document.documentElement.clientHeight-346,
      tablePage: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      cid:0,
    }
  },
  methods:{
    //切换分页
    currentPage(page) {
      this.tablePage.currentPage = page;
      this.getOrders();
    },
    /*获取订单列表-全部订单*/
    getOrders(){
      /*state 0 待支付 1进行中（待服务） 2待评价 3已完成 4售后退款 6待收货（服务中） -2 全部订单*/
      getOrdersInfo({
        cid: this.cid,
        state: 6,
        uid: this.cid,
        page:this.tablePage.currentPage,
        pageLimit:this.tablePage.pageSize,
      }).then(res=>{
        if (res.code==200){
          if (res.data){
            this.orderData=res.data;
            this.tablePage.total=res.data.length;
          }
        }
      })
    }
  },
  mounted() {
    this.getOrders();
  },
  beforeMount() {
    this.cid=JSON.parse(sessionStorage.getItem('loginData')).cid;
  }
}
</script>

<style scoped lang="scss">
.inService-container {
  background: #ffffff;

  .inService-content {
    padding: 25px 25px 0px;
    .table-header {
      width: 100%;
      border-spacing: 0px;
      tr {
        background: #F0F5F9;
        cursor: pointer;
        th {
          text-align: center;
          font-weight: normal;
          font-size: 16px;
          color: #333333;
          padding: 15px 20px;
        }
        .th-first {
          width: 50%;
          text-align: left;
          font-weight: normal;
          font-size: 16px;
          color: #333333;
          padding: 15px 20px;
        }
      }
    }
    .order-table{
      margin-top: 10px;
    }
  }
}
</style>